import React from 'react'
import { CreateTableState, List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { datesConfig } from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/ModifyList/configs/dateTableConfig'

const DatesList = ({ updateRow, rows, resource, EmptyComponent }) => {
  const tableConfig = datesConfig({
    updateRow,
    resource,
  })

  const tableState = CreateTableState(tableConfig, rows)

  return (
    <List
      config={tableConfig}
      table={tableState}
      EmptyComponent={EmptyComponent}
    />
  )
}

export default DatesList

DatesList.propTypes = {
  updateRow: PropTypes.func,
  rows: PropTypes.array,
  resource: PropTypes.string,
  EmptyComponent: PropTypes.elementType,
}
